import { GOOGLE_CONTACT_SCRIPT_URL } from '../config/contactChannels';

/**
 * POST JSON to Google Apps Script doPost — expects { name, phone, topic, message }.
 * Returns { ok, skipped?, error?, usedFallback? }
 */
export async function submitContactToSheet({ name, phone, topic, message }) {
  if (!GOOGLE_CONTACT_SCRIPT_URL) {
    return { ok: false, skipped: true };
  }

  const payload = JSON.stringify({ name, phone, topic, message });

  /* text/plain avoids CORS preflight that often breaks browser → Apps Script with application/json */
  const post = async (mode) =>
    fetch(GOOGLE_CONTACT_SCRIPT_URL, {
      method: 'POST',
      mode,
      redirect: 'follow',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: payload,
    });

  try {
    const res = await post('cors');
    const text = await res.text();
    let data = {};
    try {
      data = text ? JSON.parse(text) : {};
    } catch {
      /* non-JSON */
    }
    if (res.ok && data.status === 'success') {
      return { ok: true };
    }
    if (res.ok && data.status === 'error') {
      return { ok: false };
    }
  } catch {
    /* try no-cors */
  }

  try {
    await post('no-cors');
    return { ok: true, opaque: true };
  } catch (error) {
    return { ok: false, error };
  }
}

/** mailto fallback — same fields as the Apps Script row */
export function getContactMailtoHref(content, { name, phone, topic, message }) {
  const subject = encodeURIComponent(`HumPro — ${topic}`);
  const body = encodeURIComponent(
    `Name: ${name}\nPurpose: ${topic}\nContact number: ${phone}\n\nMessage:\n${message}\n`
  );
  return `mailto:${content.common.mail}?subject=${subject}&body=${body}`;
}
